import emiter, { _EVENTS, EVENT_VEHICLE_TYPE, EVENT_VEHICLE_VIEW_CAR } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import { Modal, message } from 'antd';
import { DEFAULT_PAGE_INFO } from '../../../consts';
import { API_VEHICLE_DETAIL } from '../../carRental/_';

export const useNotificationListTemplate = () => {
	const searchFormReset = (form: any) => {
		emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, {
			...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
		});
	};
	const searchFormFinish = (form: any) => {
		emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, {
			...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
		});
	};

	const onSearchAction = (load: any) => {
		emiter.on(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, load);
	};

	const search = (params: any) => request.get(_APIS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, { params });

	const update = (params: any) => request.post(_APIS.NOTIFICATION.NOTIFICATION_LIST.READ, params);

	const getDetail = (params: any) => request.get(_APIS.ORDER_MANAGEMENT.ORDER_LIST.DETAIL, { params });

	const pollingMsg = (params: any) => request.get(_APIS.NOTIFICATION.NOTIFICATION_LIST.POLLING_MSG, { params });

	const getSaasApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.CONFIG, { params });

	// const deleteData = (params: any) => request.post(_APIS.NOTIFICATION.NOTIFICATION_LIST.DELETE, params);

	const getCarDetail = (params: any) => request.get(API_VEHICLE_DETAIL, { params });

	const readAll = () => request.get(_APIS.NOTIFICATION.NOTIFICATION_LIST.READ_ALL);

	const readLater = (params: any) => request.post(_APIS.NOTIFICATION.NOTIFICATION_LIST.READ_LATER, params);


	const tablePagination = (data: any) => {
		emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, data);
	};

	const searchByData = (query: any = {}) => {
		emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, query);
	};

	const tableActionEdit = async (data: any) => {
		// const res = await getDrawerDetail(data)
		// emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.EDIT, {
		//     ...res,
		//     drawerInfo: {
		//         disabled: false,
		//         title: '编辑'
		//     }
		// });
	};

	const tableActionView = async (data: any) => {
		if (data && data.item_type === 1 && data.event_type !== '车辆批量创建') {
			const res = await getCarDrawerDetail(data);
			emiter.emit(EVENT_VEHICLE_TYPE, 'view');
			emiter.emit(EVENT_VEHICLE_VIEW_CAR, res?.data);
		} else if (data && data.item_type === 1 && data.event_type === '车辆批量创建') {
			window.location.href = data.url
		} else if (data && data.item_type === 0){
			const res = await getDrawerDetail(data);
			// const res = await getDrawerDetail({ order_code: 4324123412423144 })
			emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.VIEW, {
				detail: res?.data,
				drawerInfo: {
					disabled: true,
					type: 'view',
					title: '查看',
				},
			});
		} else if (data && [3, 4, 5, 6, 7].includes(data.item_type) && [4,5].includes(data.channel)) {
			emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.MODAL,data)
		}
	};

	const tableActionAdd = (data: any) => {
		// emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.ADD, {
		//     ...data,
		//     drawerInfo: {
		//         disabled: false,
		//         title: '新建'
		//     }
		// });
	};

	const getDrawerDetail = async (data: any) => {
		if (data.item_code) {
			const res = await getDetail({
				order_code: data.item_code,
			});
			return res;
		}
	};

	const getCarDrawerDetail = async (data: any) => {
		if (data.item_code) {
			const res = await getCarDetail({
				veh_code: data.item_code,
			});
			return res;
		}
	};

	const drawerSubmit = async (data: any, echoData: any) => {
		// if (echoData.rule_code) {
		//     await update({ ...data, rule_code: echoData.rule_code })
		// } else {
		//     await add(data)
		// }
		// message.success('操作成功');
		// emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, {
		// });
	};

	const getRelatedGoods = (params: any) => {
		// if (params.status === undefined || params.status === '') {
		//     params.status = -1
		// }
		// if (params.veh_num_type === undefined || params.veh_num_type === '') {
		//     params.veh_num_type = -1
		// }
		// return request.post(_APIS.NOTIFICATION.CAR_MODEL_PRICE.SEARCH,  params)
	};

	const deleteItem = async (data: any) => {
		// const { confirm } = Modal;
		// const res = await getRelatedGoods({
		//     rule_code: data.rule_code,
		//     rule_type: 1,
		//     page: 1,
		//     page_size: 1000,
		// })
		// const total = res?.data?.total
		// if (total) {
		//     message.error('请先解绑应用的车型商品')
		// } else {
		//     confirm({
		//         title: '确认删除该条预定规则?',
		//         content: '',
		//         onOk: async () => {
		//             await deleteData({
		//                 rule_code: data.rule_code,
		//             })
		//             message.success('操作成功');
		//             emiter.emit(_EVENTS.NOTIFICATION.NOTIFICATION_LIST.SEARCH, {
		//             });
		//         },
		//         onCancel() {
		//         },
		//     });
		// }
	};

	return {
		searchFormReset,
		searchFormFinish,
		search,
		update,
		searchByData,
		// getDetail,
		// deleteData,
		onSearchAction,
		tablePagination,
		tableActionEdit,
		tableActionView,
		tableActionAdd,
		getDrawerDetail,
		drawerSubmit,
		deleteItem,
		pollingMsg,
		getSaasApolloConfig,
		readAll,
		readLater,
	};
};
